import { Button, MenuItem, Select, TextField } from '@mui/material'
import React from 'react'
import { useAdvancedSearchStore } from '../hooks/useAdvancedSearch'

const SaleRecordRow = ({ filterIndex }) => {
    const filterRow = useAdvancedSearchStore(s => s.appliedSaleRecords?.[filterIndex])
    const saleRecords = useAdvancedSearchStore(s => s.saleRecords)
    const modifyAppliedSaleRecord = useAdvancedSearchStore(s => s.modifyAppliedSaleRecord)
    const changeAddNewSaleRecord = useAdvancedSearchStore(s => s.changeAddNewSaleRecord)

    const { field, value, type } = filterRow || {}

    if (!filterRow) return <></>

    return (
        <div className='flex flex-1 [&>div]:w-[33.33%] mb-5 space-x-4'>
            {field !== undefined && <div className='flex'>
                <Select
                    fullWidth
                    value={field}
                    MenuProps={{
                        style: { zIndex: 35001 }
                    }}
                    onChange={(e) => {
                        modifyAppliedSaleRecord(filterIndex, 'field', e.target.value)

                        modifyAppliedSaleRecord(filterIndex, 'value', "")
                        changeAddNewSaleRecord(true)
                        const child = saleRecords.find((item) => item.value === e.target.value)
                        if (child) {
                            modifyAppliedSaleRecord(filterIndex, 'type', child.type)
                        } else {
                            modifyAppliedSaleRecord(filterIndex, 'type', "text")
                        }
                    }}
                >
                    {saleRecords.map((option) => (
                        <MenuItem key={option.value} value={option.value}>
                            {option.label}
                        </MenuItem>
                    ))}
                </Select>
            </div>}
            {value !== undefined ? <div>
                {type === "text" && <TextField

                    fullWidth
                    value={value}
                    onChange={(e) => {
                        modifyAppliedSaleRecord(filterIndex, 'value', e.target.value)
                    }}

                />}
                {type === "date" && <TextField
                    fullWidth
                    value={value}
                    type='date'
                    onChange={(e) => {
                        modifyAppliedSaleRecord(filterIndex, 'value', e.target.value)
                    }}

                />}
            </div> : <div className='w-full' />}
        </div>
    )
}

function SaleRecordsFilter() {
    const appliedSaleRecordFilters = useAdvancedSearchStore(s => s.appliedSaleRecords)
    const addNewAppliedSaleRecord = useAdvancedSearchStore(s => s.addNewAppliedSaleRecord)
    const canAddNewSaleRecord = useAdvancedSearchStore(s => s.canAddNewSaleRecord)

    return (
        <div className='mx-[50px]'>
            <div className='flex flex-1 [&>div]:w-[33.33%] space-x-4'>
                <div>
                    <span>Sale Record</span>
                </div>
                <div>
                    <span>SKU</span>
                </div>
            </div>
            <div className='mt-5'>
                {
                    appliedSaleRecordFilters.map((_, index) => (
                        <SaleRecordRow key={index} filterIndex={index} />
                    ))
                }
            </div>
            <div className='mt-5'>
                <Button disabled={!canAddNewSaleRecord} variant='contained' className='bg-secondary-500 hover:bg-secondary-500' onClick={addNewAppliedSaleRecord}>
                    Add new filter
                </Button>
            </div>
        </div>
    )
}

export default SaleRecordsFilter